import { CSSObject } from '@chakra-ui/react';

export const ExoticSelectionText: CSSObject = {
  color: 'alpha.700',
};
